// components
import maPaginator from '@/components/paginator'
import maFilters from '../../components/filters'
import maModal from '@/components/modal'
import maInputText from '@/components/input/modules/text'
import maAdminView from '../adminView'
import maEmpty from '@/components/empty'

// api
import {
  apiGetAdminDamagesCoefficients,
  apiPatchAdminDamagesCoefficients
} from '@/services/API/admin'

export default {
  name: 'coefficients',
  data: function () {
    return {
      coefficient: {
        repCodeType: null,
        description: null,
        coefMat: null,
        coefMo: null,
        matSRen: null,
        price: null
      }
    }
  },
  extends: maAdminView,
  components: {
    maPaginator,
    maFilters,
    maModal,
    maInputText,
    maEmpty
  },
  methods: {
    handleSearch: function () {
      apiGetAdminDamagesCoefficients(this.currentPage, this.filterWarrantyId, this.filterSubwarrantyId)
        .then(coefficients => {
          this.table = coefficients.results
          this.totalPages = coefficients.total_pages || 0
        })
    },
    handleEdit: function (repCodeType, description, coefMat, coefMo, matSRen, price) {
      this.coefficient = { repCodeType, description, coefMat, coefMo, matSRen, price }
      this.$refs.adminEditModal.showModal = true
    },
    resetEditValues: function () {
      this.coefficient.repCodeType = null
      this.coefficient.description = null
      this.coefficient.coefMat = null
      this.coefficient.coefMo = null
      this.coefficient.matSRen = null
      this.coefficient.price = null
    },
    handleSave: function () {
      apiPatchAdminDamagesCoefficients(
        this.coefficient.repCodeType,
        this.coefficient.description,
        this.coefficient.coefMat,
        this.coefficient.coefMo,
        this.coefficient.matSRen,
        this.coefficient.price
      )
        .then(() => {
          this.handleSearch()
          this.throwNotification(this.$t('notifications.paramChanged.title'), this.$t('notifications.paramChanged.body'), 'OK')
          this.$refs.adminEditModal.showModal = false
        })
        .catch(() => {
          this.throwNotification(this.$t('notifications.error.0.title'), this.$t('notifications.error.0.body'), 'KO')
        })
    }
  },
  mounted: function () {
    this.handleSearch()
  }
}
